import { render, staticRenderFns } from "./CopyInput.vue?vue&type=template&id=4f6c87d3"
import script from "./CopyInput.vue?vue&type=script&lang=js"
export * from "./CopyInput.vue?vue&type=script&lang=js"
import style0 from "./CopyInput.vue?vue&type=style&index=0&id=4f6c87d3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports